export const EntityType = {
  MoneyBills: 'moneyBills',
  MoneyBag: 'moneyBag',
  SuperMoneyBag: 'superMoneyBag',
  Ink: 'ink',
  Fog: 'fog',
  SnowDrifts: 'snowDrifts'
} as const;
export type EntityTypeKeys = keyof typeof EntityType;
export type EntityTypeValues = typeof EntityType[EntityTypeKeys];
